import { useEffect, useState } from "react";
import API, { fmt } from "@/lib/api";
import { PageHeader, StatusPill, Loader } from "@/components/ui-bits";

export default function Transactions() {
  const [txns, setTxns] = useState(null);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    API.get("/transactions", { params: filter ? { type: filter } : {} }).then((r) => setTxns(r.data.transactions));
  }, [filter]);

  const types = ["", "deposit_approved", "package_activation", "level_1_income", "level_2_income",
    "level_3_income", "magic_card_income", "withdrawal_request", "withdrawal_approved", "pp_transfer"];

  return (
    <div>
      <PageHeader title="Transactions" subtitle="Your immutable ledger — every financial event with gross, fee, net, source & destination." testid="transactions-header"
        right={
          <select data-testid="txn-filter" value={filter} onChange={(e) => setFilter(e.target.value)}
            className="rounded-xl bg-white/5 border border-white/10 px-4 py-2.5 text-sm text-white outline-none">
            {types.map((t) => <option key={t} value={t} className="bg-slate-900">{t ? t.replace(/_/g, " ") : "All types"}</option>)}
          </select>
        }
      />
      {!txns ? <Loader /> : (
        <div className="glass rounded-2xl p-2 sm:p-4" data-testid="transactions-table">
          {txns.length === 0 ? <p className="text-sm text-slate-500 py-10 text-center">No transactions.</p> : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead><tr className="text-left text-xs uppercase tracking-wide text-slate-500 border-b border-white/10">
                  <th className="py-3 px-3">Date</th><th className="py-3 px-3">Type</th><th className="py-3 px-3">From ID</th><th className="py-3 px-3">Gross</th>
                  <th className="py-3 px-3">Fee</th><th className="py-3 px-3">Net</th><th className="py-3 px-3">Destination</th><th className="py-3 px-3 text-right">Status</th>
                </tr></thead>
                <tbody>
                  {txns.map((t) => (
                    <tr key={t.id} className="border-b border-white/5 last:border-0 hover:bg-white/[0.02]">
                      <td className="py-3 px-3 font-num text-slate-400 whitespace-nowrap">{new Date(t.created_at).toLocaleString()}</td>
                      <td className="py-3 px-3 text-white capitalize whitespace-nowrap">{t.type.replace(/_/g, " ")}</td>
                      <td className="py-3 px-3 font-num text-cyan-300 text-xs">{t.from_code || "—"}</td>
                      <td className="py-3 px-3 font-num text-white">{fmt(t.gross)}</td>
                      <td className="py-3 px-3 font-num text-rose-400">{t.fee ? fmt(t.fee) : "—"}</td>
                      <td className="py-3 px-3 font-num text-emerald-300">{fmt(t.net)}</td>
                      <td className="py-3 px-3 font-num text-slate-400 text-xs">{t.destination}</td>
                      <td className="py-3 px-3 text-right"><StatusPill status={t.status} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
